import React from 'react';
import { Link } from 'react-router-dom';
import { getPublicAssetPath } from '../config';

const ServiceUnavailable: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <img src={getPublicAssetPath('/le_long.png')} alt="Legitimu Logo" className="h-12" />
        </div>

        {/* 503 Illustration */}
        <div className="mb-8">
          <div className="relative inline-block">
            <div className="text-9xl font-bold text-orange-100">503</div>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="fa-solid fa-screwdriver-wrench text-6xl text-orange-400"></i>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Layanan Sedang Tidak Tersedia</h1>
          <p className="text-lg text-gray-600 mb-2">
            Maaf, layanan sedang dalam pemeliharaan atau mengalami gangguan sementara.
          </p>
          <p className="text-sm text-gray-500">
            Tim kami sedang bekerja untuk memperbaiki masalah ini. Silakan coba lagi dalam beberapa saat.
          </p>
        </div>

        {/* Maintenance Info */}
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-6 mb-8">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <i className="fa-solid fa-info-circle text-orange-600 text-2xl"></i>
            </div>
            <div className="ml-4 text-left">
              <h3 className="text-sm font-semibold text-orange-900 mb-2">Informasi Pemeliharaan</h3>
              <p className="text-sm text-orange-700">
                Layanan akan kembali normal dalam waktu singkat. Kami mohon maaf atas ketidaknyamanan ini.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center px-6 py-3 bg-violet-600 text-white text-sm font-medium rounded-lg hover:bg-violet-700 transition-colors"
          >
            <i className="fa-solid fa-arrow-rotate-right mr-2"></i>
            Coba Lagi
          </button>
          <Link
            to="/dashboard"
            className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            <i className="fa-solid fa-home mr-2"></i>
            Kembali ke Dashboard
          </Link>
        </div>

        {/* Status Updates */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 mb-8">
          <h3 className="text-sm font-semibold text-gray-900 mb-4 flex items-center justify-center">
            <i className="fa-solid fa-clock text-violet-600 mr-2"></i>
            Perkiraan Waktu Pemulihan
          </h3>
          <div className="flex items-center justify-center space-x-6">
            <div className="text-center">
              <div className="text-2xl font-bold text-violet-600">15-30</div>
              <div className="text-xs text-gray-600 mt-1">Menit</div>
            </div>
            <div className="text-gray-300">|</div>
            <div className="text-center">
              <div className="text-sm text-gray-600">Status</div>
              <div className="text-xs font-medium text-orange-600 mt-1">Maintenance</div>
            </div>
          </div>
        </div>

        {/* Helpful Links */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Butuh Bantuan?</h3>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/support"
              className="inline-flex items-center px-4 py-2 text-sm text-violet-600 hover:text-violet-700 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-life-ring mr-2"></i>
              Hubungi Support
            </Link>
            <Link
              to="/documentation"
              className="inline-flex items-center px-4 py-2 text-sm text-violet-600 hover:text-violet-700 hover:bg-violet-50 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-book mr-2"></i>
              Lihat Dokumentasi
            </Link>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8">
          <p className="text-xs text-gray-500">
            Jika masalah berlanjut, silakan hubungi tim support kami di{' '}
            <a href="mailto:support@legitimu.com" className="text-violet-600 hover:text-violet-700 font-medium">
              support@legitimu.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceUnavailable;

